import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { addLicense, removeLicense, setAiUsageAllowed } from 'Pods/SearchPage/Store/actions/licenses'
import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { getLicenseFiltersConfig, aiUsageFiltersConfig } from './constants'

const stripLabels = groups => groups.map(group => ({ ...group, label: '' }))

function LicenseContent({ hideGroupLabels = false }) {
  const licenses = useSearchPageStore(state => state.licenses ?? [LICENSE_TYPE.ALL])
  const aiUsageAllowed = useSearchPageStore(state => state.aiUsageAllowed ?? false)

  const handleLicenseFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      addLicense(value)
    } else {
      removeLicense(value)
    }
  }, [])

  const handleAiUsageFilterChange = useCallback((_, _value, isOn) => {
    setAiUsageAllowed(isOn)
  }, [])

  const licenseFiltersConfig = useMemo(() => {
    const config = getLicenseFiltersConfig(aiUsageAllowed)
    return hideGroupLabels ? stripLabels(config) : config
  }, [aiUsageAllowed, hideGroupLabels])

  const aiConfig = useMemo(
    () => (hideGroupLabels ? stripLabels(aiUsageFiltersConfig) : aiUsageFiltersConfig),
    [hideGroupLabels],
  )

  const selectedAiUsageFilter = useMemo(
    () => [aiUsageAllowed ? 'ai_usage_allowed' : 'no_ai_usage_allowed'],
    [aiUsageAllowed],
  )

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={licenseFiltersConfig}
        selectedFilters={licenses}
        onFiltersChange={handleLicenseFilterChange}
        isControlled
        useNewCheckboxes
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <FiltersSidebar
        isCollapsible={false}
        filters={aiConfig}
        selectedFilters={selectedAiUsageFilter}
        onFiltersChange={handleAiUsageFilterChange}
        hideLastDivider
        isControlled
        hideShowMore
        useNewCheckboxes
        baseFormWrapperClassName="filter-wrapper__content"
      />
    </>
  )
}

LicenseContent.propTypes = {
  hideGroupLabels: bool,
}

export default memo(LicenseContent)
